export default __webpack_public_path__ + "static/media/role_tank.7b07633b.png";